<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-user-chart" class="q-mb-sm" /> {{ $t('users_on_campaign') }}
        </div>

        <q-tabs v-model="tab">
            <q-tab slot="title" name="user_data" :label="$t('user_data')" />
            <q-tab slot="title" name="sales_history" :label="$t('sales_history')" />
            <q-tab slot="title" name="photo_upload_history" :label="$t('photo_upload_history')" />
            <q-tab slot="title" name="point_history" :label="$t('point_history')" />
            <q-tab slot="title" name="level_history" :label="$t('level_history')" />
            <q-tab slot="title" name="redeem_history" :label="$t('redeem_history')" />

            <q-tab-pane name="user_data">
                <rewards-level-register :data="data" :id="id_rewards_level" />
            </q-tab-pane>

            <q-tab-pane name="point_history">
               <history-points :id="id_rewards_level" />
            </q-tab-pane>

            <q-tab-pane name="sales_history">
               <sales-history :user_id="id_rewards_level" />
            </q-tab-pane>

            <q-tab-pane name="photo_upload_history">
               <photo-upload-history :user_id="id_rewards_level" />
            </q-tab-pane>

            <q-tab-pane name="level_history">
                <history-level :id="id_rewards_level" />
            </q-tab-pane>

            <q-tab-pane name="redeem_history">
                <redeem-history :user_id="id_rewards_level" />
            </q-tab-pane>
        </q-tabs>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'users_reward_levels' })" />
            </div>
        </div>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import RewardsLevelRegister from 'components/admin/rewards/RewardsLevelRegister'
import HistoryPoints from 'components/admin/rewards/HistoryPoints'
import PhotoUploadHistory from 'components/admin/rewards/PhotoUploadHistory'
import HistoryLevel from 'components/admin/rewards/HistoryLevel'
import SalesHistory from 'components/admin/redeems/SalesHistory'
import RedeemHistory from 'components/admin/redeems/RedeemHistory'

export default {
    i18nOptions: { namespaces: ['custom', 'common', 'profile', 'training', 'admin', 'rewards'] },

    components: {
        'rewards-level-register': RewardsLevelRegister,
        'history-points': HistoryPoints,
        'history-level': HistoryLevel,
        'sales-history': SalesHistory,
        'photo-upload-history': PhotoUploadHistory,
        'redeem-history': RedeemHistory
    },

    data() {
        return {
            tab: 'user_data',
            id_rewards_level: '',
            data:{}
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            reload_content: 'common/reload_content',
            reward_levels: 'registration_lists/reward_levels',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get(`/admin_rewards/users_reward_levels/${this.id_rewards_level}/`, this.getHeader)
            .then(response => {
                this.data = response.data
                this.$store.dispatch('campaigns/SET_USER_ID', [response.data.user_id])
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        }
    },

    watch: {
        tab: function() {
            if (this.tab === 'user_data') this.fetchData()
        }
    },

    created() {
        this.id_rewards_level = this.$route.params.id
        this.fetchData()
    }
}
</script>

<style>

</style>
